import { render, staticRenderFns } from "./CertificateModel.vue?vue&type=template&id=5840e930&scoped=true&"
import script from "./CertificateModel.vue?vue&type=script&lang=js&"
export * from "./CertificateModel.vue?vue&type=script&lang=js&"
import style0 from "./CertificateModel.vue?vue&type=style&index=0&id=5840e930&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840e930",
  null
  
)

export default component.exports